 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {useMutation} from 'react-relay'


const mutation = graphql`
  mutation useUploadIdPMetadataMutation($file: File!, $orgId: ID!) {
    uploadIdPMetadata(file: $file, orgId: $orgId) {
      ... on ErrorPayload {
        error {
          message
        }
      }
      ... on UploadIdPMetadataSuccess {
        url
      }
    }
  }
`





export const useUploadIdPMetadata = () => {
  const [commit, submitting] = useMutation(mutation)
  



  const execute = (config) => {
    const {variables} = config
    const {orgId} = variables
    return commit({
      updater: (store) => {
        const org = store.get(orgId)
        _optionalChain([org, 'optionalAccess', _ => _.setValue, 'call', _2 => _2(orgId, 'id')])
      },
      // allow components to override default handlers
      ...config
    })
  }
  return [execute, submitting] 
}
